//import setAuthorizationToken from '../utils/setAuthorizationToken';
import jwtDecode from 'jwt-decode';
import isEmpty from 'lodash/isEmpty';

export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const PARTICIPANT_FETCHED = 'PARTICIPANT_FETCHED';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const START_NEW_EXAM = 'START_NEW_EXAM';
export const SET_EXAM_READY = 'SET_EXAM_READY';
export const APP_SYNCED = 'APP_SYNCED';


export function setParticipants(participants) {
  return {
    type: SET_PARTICIPANTS,
    participants
  }
}

export function startNewExam(exam){
  return {
    type: START_NEW_EXAM,
    exam
  }
}

export function appSynced(exam){
  return {
    type: APP_SYNCED,
    exam
  }
}

export function addParticipant(participant) {
  return {
    type: ADD_PARTICIPANT,
    participant
  }
}

export function participantFetched(participant) {
  return {
    type: PARTICIPANT_FETCHED,
    participant
  }
}

export function setExamReady(data){
  return {
    type: SET_EXAM_READY,
    data
  }
}

export function userLoggedIn(user) {
  return {
    type: USER_LOGGED_IN,
    user
  }
}

export function saveParticipant(data) {
  var token = localStorage.token;
  return dispatch => {
    return fetch('http://dev-bicams-api.azurewebsites.net/api/Participants', {
      mode: 'cors',
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      }
    }).then(handleResponse)
    .then(data => dispatch(addParticipant(data.participant)));
  }
}


export function fetchParticipants() {
  var token = localStorage.token;
  return dispatch => {
    fetch('http://dev-bicams-api.azurewebsites.net/api/Participants', {
      mode:'cors',
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    }).then(res => res.json())
      .then(data => dispatch(setParticipants(data.participants)));
  }
}

export function fetchParticipant(id) {
  var token = localStorage.token;
  return dispatch => {
    fetch(`http://dev-bicams-api.azurewebsites.net/api/Participants/${id}`,  {
      mode:'cors',
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    }).then(res => res.json())
      .then(data => dispatch(participantFetched(data.participant)));
  }
}

export function logout(){
  return dispatch => {
    localStorage.removeItem('token');
    // change to session if we want it to expire or go when the window is closed
    //setAuthorizationToken(false);
    dispatch(userLoggedIn({}));
  }
}

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function setToken(data) {
  if(isEmpty(data.Error)){
    // change to session if we want it to expire or go when the window is closed
    localStorage.setItem('token', data.Token);
    return data.Token;
  }else{
    let error = new Error(data.Error);
    throw error;
  }
}


export function login(data){
  return dispatch => {
    return fetch('http://dev-bicams-api.azurewebsites.net/api/Login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: data.email,
        pw: data.pw,
      })
    }).then(handleResponse)
    .then(setToken)
    .then(jwtDecode)
    .then(data => dispatch(userLoggedIn(data)));
  }
}

export function newExam(data){
  var token = localStorage.token;
  // change to session if we want it to expire or go when the window is closed
  return dispatch => {
    return fetch('http://dev-bicams-api.azurewebsites.net/api/StartExam', {
      method: 'post',
      mode: 'cors',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      }
       
    }).then(handleResponse)
    .then(data => dispatch(startNewExam(data.exam)));
  }
}

export function syncExam(){
  var token = localStorage.token;
  return dispatch => {
    return fetch('http://dev-bicams-api.azurewebsites.net/api/StartExaminerExam',  {
      mode:'cors',
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    }).then(res => res.json())
      .then(data => dispatch(appSynced(data.exam)));
  }
}

export function checkSync() {
  var token = localStorage.token;
  return dispatch => {
    fetch('http://dev-bicams-api.azurewebsites.net/api/CheckSync', {
      mode:'cors',
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    }).then(res => res.json())
      .then(data => dispatch(setExamReady(data)));
  }
}


// WEBPACK FOOTER //
// ./src/actions.js